import * as React from 'react'

import classNames from 'classnames'

import { styles } from './index.styles'
import './index.styles.css'

interface Props {
  componentRef?: () => void
  size?: 'normal' | 'small'
  fullHeight?: boolean
}

export const PanesPad = ({
  children,
  componentRef,
  size = 'normal',
  fullHeight = false,
}: React.PropsWithChildren<Props>) => {
  const className = classNames(styles.pad, styles[size], {
    [styles.fullHeight]: fullHeight,
  })

  return (
    <div className={className} ref={componentRef}>
      {children}
    </div>
  )
}

export default PanesPad
